import { ApiError, type ApiResponse } from '@/types/api.types'

export const unwrapResponse = <T, E = number>(
  response: ApiResponse<T, E>,
  options?: { requireValue?: boolean }
): T => {
  if (!response.success) {
    throw new ApiError<E>(
      response.errorMessage ?? 'Generic API Error',
      response.errorCode
    )
  }

  if (options?.requireValue && response.value == null) {
    throw new ApiError('Expected value but none returned', response.errorCode)
  }

  return response.value as T
}

// For API responses that extend ApiResponse with additional properties
// e.g., CreateCheckoutSessionResult which has sessionId and sessionUrl
export const unwrapCustomResponse = <T extends ApiResponse<any, E>, E = number>(
  response: T,
  options?: { requireValue?: boolean }
): T => {
  if (!response.success) {
    throw new ApiError<E>(
      response.errorMessage ?? 'Generic API Error',
      response.errorCode
    )
  }

  if (options?.requireValue && response.value == null) {
    throw new ApiError('Expected value but none returned', response.errorCode)
  }

  return response
}
